module.exports = __webpack_public_path__ + "img/az_logo@2x.565a073c.png";